import React from 'react';
import Icon from '~/app/common/Icon';
import useTranslation from '~/app/hooks/useTranslation';
import { useStoreState } from '~/store';
import { WorkOrderSummary } from '~/workorder/types';
import classes from './style.module.scss';

export type SummaryComponent = React.FC<SummaryProps>;

export interface SummaryProps {
    summary: WorkOrderSummary;
}

const Summary: SummaryComponent = ({ summary }) => {
    const { t } = useTranslation('workorder');

    const { totalHours, totalMaterials, totalParts } = summary ?? { totalHours: 0, totalMaterials: 0, totalParts: 0 };

    const taskCount = useStoreState(state => state.workOrder.taskCount);
    const { total, done } = taskCount;

    return (
        <div className={classes.card}>
            <h2 className={classes.title}>{t('detail.summaryTitle')}</h2>
            <div className={classes.rows}>
                <div className={classes.row}>
                    <span className={classes['icon-wrap']} aria-hidden>
                        <Icon name="schedule" size={18} />
                    </span>
                    <span>{t('detail.summaryHoursRegistered', { hours: totalHours })}</span>
                </div>
                <div className={classes.row}>
                    <span className={classes['icon-wrap']} aria-hidden>
                        <Icon name="hardware" size={18} />
                    </span>
                    <span>
                        {t(
                            totalParts === 1
                                ? 'detail.summaryPartsRegistered_one'
                                : 'detail.summaryPartsRegistered_other',
                            { count: totalParts },
                        )}
                    </span>
                </div>
                <div className={classes.row}>
                    <span className={classes['icon-wrap']} aria-hidden>
                        <Icon name="build" size={18} />
                    </span>
                    <span>
                        {t(
                            totalMaterials === 1
                                ? 'detail.summaryMaterialsRegistered_one'
                                : 'detail.summaryMaterialsRegistered_other',
                            { count: totalMaterials },
                        )}
                    </span>
                </div>
                <div className={classes.row}>
                    <span className={classes['icon-wrap']} aria-hidden>
                        <Icon name="assignment" size={18} />
                    </span>
                    <span>{t('detail.summaryTasksCompleted', { done, total })}</span>
                </div>
            </div>
        </div>
    );
};

export default Summary;
